<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>基础信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <!-- <div class="input-box">
                    <p>学院：</p>
                    <a-input class="input"  disabled/>
                </div> -->
                <div class="input-box input-box-huge">
                    <p>论文题目：</p>
                    <a-input class="input" v-model="paperTitle" disabled/>
                </div>
                <div class="input-box">
                    <p>学生姓名：</p>
                    <a-input class="input" v-model="studentName" disabled/>
                </div>
                <div class="input-box">
                    <p>学号：</p>
                    <a-input class="input" v-model="studentNo" disabled/>
                </div>
                <!-- <div class="input-box">
                    <p>专业：</p>
                    <a-input class="input"  disabled/>
                </div> -->
                <div class="input-box">
                    <p>指导老师：</p>
                    <a-input class="input" v-model="teacherName" disabled/>
                </div>
                <!-- <div class="input-box">
                    <p>职称：</p>
                    <a-input class="input"  disabled/>
                </div>
                <div class="input-box">
                    <p>教师所在学院：</p>
                    <a-input class="input"  disabled/>
                </div> -->
                
                <!-- <div class="input-box" v-if="info.collegeUserId==userId">
                    <p>督导老师：</p>
                    <a-input class="input" v-model="info.collegeUserName" disabled/>
                </div> -->
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>学院自查质量评价表</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="table">
                    <a-table
                        :columns="columns"
                        :data-source="data"
                        bordered
                        size="middle"
                        :pagination="{ defaultPageSize	: 20,hideOnSinglePage:true}">
                    <template
                        v-for="col in ['indexScore']"
                        :slot="col"
                        slot-scope="text, record, index"
                        >
                        <div :key="col">
                            <a-input-number
                            v-if="true"
                            style="margin: -5px 0"
                            :value="text"
                            :max=parseFloat(record.indexFullScore)
                            @blur="e => handleChange(e.target.value, record.indexId, col)"
                            :dsabled="type=='look'"
                            />
                            <template v-else>
                            {{ text }}
                            </template>
                        </div>
                        </template>


                    </a-table>
                </div>
            </div>
        </div>
        <div class="info-main">      
            <div class="input-box input-box-large">
                <p>学院自查评阅意见：</p>
                <a-textarea class="input" v-model="info.collegeComment" :rows="4" :dsabled="type=='look'"/>
            </div>
        </div>
        <div class="btn-box">
            <a-button type="primary" v-if="type!='look'" @click="sub">保存</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { add,update,info,college } from '@/baseAPI/undergraduate/culture/paperCheck'

    const columns = [

        {
            title: '考评项目',
            dataIndex: 'indexPname',
            width: 150,
            fixed: 'left',
            align:'center',
            // colSpan:2,
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                if (index === 1) {
                    obj.attrs.rowSpan = 3;
                }
                if (index === 2|| index === 3) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 4) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 5) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 6) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 7) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 8) {
                    obj.attrs.rowSpan = 3;
                }
                if (index === 9 || index === 10) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 11) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 12) {
                    obj.attrs.rowSpan = 0;
                }
                return obj;
            },
        },
        {
            title: '权重',
            dataIndex: 'indexPscore',
            width: 50,
            fixed: 'left',
            align:'center',
            // colSpan:0,
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                if (index === 1) {
                    obj.attrs.rowSpan = 3;
                }
                if (index === 2|| index === 3) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 4) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 5) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 6) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 7) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 8) {
                    obj.attrs.rowSpan = 3;
                }
                if (index === 9 || index === 10) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 11) {
                    obj.attrs.rowSpan = 2;
                }
                if (index === 12) {
                    obj.attrs.rowSpan = 0;
                }
                return obj;
            },
        },
        {
            title: '考评指标',
            dataIndex:'indexTitle',
            width: 200,
            // colSpan:2,
            align:'center',
            customRender: (value, row, index) => {
                // const obj = {
                //     children: value,
                //     attrs: {},
                // };
                // if(index == 12){
                //     obj.attrs.colSpan = 0;
                // }
                // return obj;
                return value;
            }
        },
        {
            title: '分值',
            dataIndex:'indexFullScore',
            width: 50,
            // colSpan:0,
            align:'center',
            customRender: (value, row, index) => {
                // const obj = {
                //     children: value,
                //     attrs: {},
                // };
                // if(index == 12){
                //     obj.attrs.colSpan = 2;
                // }
                // return obj;
                return value;
            }
        },
        {
            title: '评价要求或要素',
            dataIndex:'indexContent',
            width: 700,
            align:'left',
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                // if (index === 9) {
                //     obj.attrs.rowSpan = 3;
                // }
                // if (index === 10 || index === 11) {
                //     obj.attrs.rowSpan = 0;
                // }
                return obj;
            },
        },
        {
            title: '得分',
            dataIndex: 'indexScore',
            width: 100,
            fixed: 'right',
            align:'center',
            scopedSlots: { customRender: 'indexScore' },
        },
        ]
    const data = [
        {   
            indexId:1,
            indexPname:'0.  否决性项目',
            indexPscore:"",
            indexTitle:'0.1  学术不端',
            indexFullScore:"0",
            indexContent:"学风严谨，无抄袭、剽窃、伪造、篡改、买卖、代写等学术不端行为",
            indexScore:""
        },
        {   
            indexId:2,
            indexPname:'1.  选题意义',
            indexPscore:"20",
            indexTitle:'1.1  价值素养',
            indexFullScore:"5",
            indexContent:"论文政治立场正确，符合国家立德树人要求和社会主义核心价值观，有利于专业培养目标的价值素养达成",
            indexScore:""
        },
        {   
            indexId:3,
            indexPname:'1.  选题意义',
            indexPscore:"20",
            indexTitle:'1.2  选题依据',
            indexFullScore:"5",
            indexContent:"选题符合专业培养目标，体现综合训练基本要求；选题与生产、科研、社会实际结合程度好，能够达到本专业的毕业要求",
            indexScore:""
        },
        {   
            indexId:4,
            indexPname:'1.  选题意义',
            indexPscore:"20",
            indexTitle:'1.3  研究意义',
            indexFullScore:"10",
            indexContent:"选题目的明确，来源于本专业领域的理论问题或实际（工程）问题；论文具有一定的理论意义或实际应用价值，具有潜在的应用前景和经济效益",
            indexScore:""
        },
        {   
            indexId:5,
            indexPname:'2.  写作安排',
            indexPscore:"20",
            indexTitle:'2.1 文献综述',
            indexFullScore:"10",
            indexContent:"能正确检索文献资料，运用恰当；对国内外最新文献分析到位、综述全面，能够体现本领域研究现状及学科发展情况",
            indexScore:""
        },
        {   
            indexId:6,
            indexPname:'2.  写作安排',
            indexPscore:"20",
            indexTitle:'2.2 进度安排',
            indexFullScore:"10",
            indexContent:"工作量饱满，写作进度安排合理，按时完成毕业论文（设计）",
            indexScore:""
        },
        {   
            indexId:7,
            indexPname:'3.  逻辑构建',
            indexPscore:"20",
            indexTitle:'3.1 逻辑构建',
            indexFullScore:"10",
            indexContent:"论文（设计）逻辑构建合理，结构清晰，能体现本专业培养目标的专门知识、专业能力和职业素养",
            indexScore:""
        },
        {   
            indexId:8,
            indexPname:'3.  逻辑构建',
            indexPscore:"20",
            indexTitle:'3.2 内容组织',
            indexFullScore:"10",
            indexContent:"论文（设计）的主题和内容框架明确，学生基础知识、研究方法、研究内容的难易程度达到所在专业的培养目标",
            indexScore:""
        },
        {   
            indexId:9,
            indexPname:'4.  专业能力',
            indexPscore:"30",
            indexTitle:'4.1 专业知识',
            indexFullScore:"10",
            indexContent:"学生能综合运用专业知识进行理论研究或解决实际（工程）问题，达到所在专业的培养目标及毕业要求",
            indexScore:""
        },
        {   
            indexId:10,
            indexPname:'4.  专业能力',
            indexPscore:"30",
            indexTitle:'4.2 分析能力',
            indexFullScore:"10",
            indexContent:"论文（设计）论证分析严谨合理，所表达的观点能体现独立分析问题的能力，关键问题或技术难点有创新",
            indexScore:""
        },
        {   
            indexId:11,
            indexPname:'4.  专业能力',
            indexPscore:"30",
            indexTitle:'4.3  研究新意',
            indexFullScore:"10",
            indexContent:"人文类专业论文（设计）观点正确，有新意；理工类专业论文对实践具有一定的指导意义",
            indexScore:""
        },
        {   
            indexId:12,
            indexPname:'5.  学术规范',
            indexPscore:"10",
            indexTitle:'5.1 论文规范',
            indexFullScore:"5",
            indexContent:"论文（设计）论点明确、论据充分、论述有理、结构完整、格式规范",
            indexScore:""
        }
        ,
        {   
            indexId:13,
            indexPname:'5.  学术规范',
            indexPscore:"10",
            indexTitle:'5.2  写作规范',
            indexFullScore:"5",
            indexContent:"文字表达清晰，书写格式、图表注释、资料引证以及参考文献规范准确",
            indexScore:""
        }
        ,
        {   
            indexId:14,
            indexPname:'总分',
            indexPscore:"",
            indexTitle:'',
            indexFullScore:"100",
            indexContent:"",
            indexScore:""
        }
    ]

    export default {
        name: '',
        data () {
            return {
                userId:'',
                type:'',
                studentName:'',
                studentNo:'',
                teacherName:'',
                paperTitle:'',
                selectedRow:{},
                info:{
                    id:'',
	                totalScore: '',
                    collegeUserId:'',
                    inspectDetails:[]
                },
                intoType:'into',
                intoCourseId:'',
                source:'',
                columns,
                data
            }
        },
        mounted () {
            this.userId=this.$store.state.user.userId
            this.type=this.$route.query.type;
            this.source=this.$route.query.source;
            this.info.id=this.$route.query.id;
            this.studentName=this.$route.query.studentName;
            this.studentNo=this.$route.query.studentNo;
            this.teacherName=this.$route.query.teacherName;
            this.paperTitle=this.$route.query.paperTitle;
            
            this.data.forEach(e=>{
                e.indexScore=''
            })

            if(this.type!='add'){
                setTimeout(()=>{
                    this.fetch();
                },500)
            }

        },
        methods:{
            fetch(){
                info(this.info.id).then(res=>{
                    this.info=res.data
                    this.data=res.data.inspectDetails
                    var totalScore=0.0
                        this.data.forEach((item,index)=>{
                            if(item.indexScore != '' && item.indexScore !=null && index < 13){
                                totalScore += parseFloat(item.indexScore)
                            }
                        })
                        this.data[13].indexScore = totalScore 
                })
            },
            formatDate (date) {
                let myyear = date.getFullYear();
                let mymonth = date.getMonth() + 1;
                let myweekday = date.getDate();
                let myHour = date.getHours();
                let myMin = date.getMinutes();
                let mySec = date.getSeconds();

                if (mymonth < 10) {
                    mymonth = '0' + mymonth;
                }
                if (myweekday < 10) {
                    myweekday = '0' + myweekday;
                }
                if (myHour < 10) {
                    myHour = '0' + myHour;
                }
                if (myMin < 10) {
                    myMin = '0' + myMin;
                }
                if (mySec < 10) {
                    mySec = '0' + mySec;
                }
                return (myyear + '-' + mymonth + '-' + myweekday + ' ' + myHour + ':' + myMin + ':' + mySec);
            },
            handleChange(value, key, column) {      
                          
                const newData = [...this.data];
                const target = newData.filter(item => key === item.indexId)[0];
                
                if (target) {
                    target[column] = value;
                    this.data = newData;
                }
                this.info.totalScore = 0.0
                this.data.forEach((item,index)=>{
                    if(item.indexScore != '' && index < 13){
                        this.info.totalScore += parseFloat(item.indexScore)
                    }
                })
                this.data[13].indexScore = this.info.totalScore 

            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['id']
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                if(isSub){
                    // this.info.evaluateDate=this.formatDate(new Date())
                    this.info.inspectDetails=this.data
                    if(this.type=='add'){
                        this.info.inspectDetails[13].indexScore=0
                        college(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增学院自查成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        college(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改学院自查成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }

    .info-main .table{
        margin-left: 10rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 66%;
    }

    .info-main .input-box-large{
        width: 88%;
    }

    .info-main .input-box-huge{
        width: 99%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .radio{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .standard{
        width: 28px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 200px;
        text-align: center;
        border-radius: 6px 0 0 6px !important;
        z-index: 0;
        pointer-events: auto;
        cursor: pointer;
        color: rgb(255, 255, 255);
        background-color: #245086;
        opacity: 0.8;
        padding: 2px 0px 0px 0px;
    }

    .standard:hover{
        opacity: 1;
    }

    .info-main .input-maxbox{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-maxbox p{
        width: 10rem;
        text-align: right;
    }

    .info-main .input-maxbox .textarea{
        width: calc(100% - 10rem);
    }

    .info-main .input-notes{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-notes .notes{
        width: calc(100% - 10rem);
        text-align: left;
        font-size: 0.9rem;
    }

    .info-main .input-notes .note-title{
        width: 10rem;
        text-align: right;
        font-size: 0.9rem;
        font-weight: bolder;
        color: black;
    }

</style>
